<template>
    <div style="position: relative;width:100%;height:100%;">
        <div id="J_prismPlayer" style="width:100%;height:100%;"></div>
    </div>
</template>

<script>
// import axios from 'axios'
import {getStstoken} from '@/request/api/user.js'
import { HTML5_FMT } from 'moment';
export default {
    props:{
        url:String,
        playerHeight: {
            type: String,
            default: '200px'
        }
    },
    data(){
        return {
            aliplayer:null
        }
    },
    created(){
    },
    mounted(){
        
        this.startVideo(this.$props.url)
    },
    methods:{
        startVideo(url){
            let self = this
            // axios.get(window.apiUrl.sts).then(res=>{
            //     let info = res.data.data.credentials
            //     let accessKeyId = info.accessKeyId
            //     let accessKeySecret = info.accessKeySecret
            //     let securityToken = info.securityToken
                
            //     // let videoId = '70d4c72e7a1371efbd640764b3ec0102'
            //     setTimeout(function(){
            //         self.getStartVideo(url,accessKeyId,securityToken,accessKeySecret)
            //     },500)   
            // })
            getStstoken().then(res=>{
                var info = res.data.credentials
                var accessKeyId = info.accessKeyId
                var accessKeySecret = info.accessKeySecret
                var securityToken = info.securityToken
                self.aliplayer = self.getStartVideo(url,accessKeyId,securityToken,accessKeySecret)
            })
            
            
            // let videoId = '70d4c72e7a1371efbd640764b3ec0102'
            // setTimeout(function(){
            //     self.getStartVideo(url,accessKeyId,securityToken,accessKeySecret)
            // },500)   
        },
        getStartVideo(videoId,accessKeyId,securityToken,accessKeySecret){
            const self = this
            return new window.Aliplayer({
                id: 'J_prismPlayer',
                width: '100%',
                height: this.playerHeight,
                vid : videoId, // 必选参数。音视频ID可以在音视频上传完成后通过控制台（路径：媒资库 > 音/视频。）或服务端接口（SearchMedia ）获取。示例：1e067a2831b641db90d570b6480f****。
                accessKeyId: accessKeyId, // 必选参数。STS临时AK对的访问密钥ID，生成STS安全令牌时返回。
                securityToken: securityToken, // 必选参数。STS安全令牌，需要调用STS服务的AssumeRole接口生成。
                accessKeySecret: accessKeySecret, // 必选参数。STS临时AK对的访问密钥，生成STS安全令牌时返回。
                region: 'cn-beijing', // 必选参数。媒体资源所在的地域标识。如cn-shanghai、eu-central-1, ap-southeast-1等。
                autoplay: false,
                useH5Prism: true,
                // 自定义皮肤布局：只保留播放/进度/时间/音量/全屏，屏蔽倍速、设置、截图、下载、收藏等按钮
                skinLayout: [
                    { name: 'bigPlayButton', align: 'blabs', x: 30, y: 80 },
                    { name: 'H5Loading', align: 'cc' },
                    { name: 'errorDisplay', align: 'tlabs', x: 0, y: 0 },
                    { name: 'infoDisplay' },
                    { name: 'tooltip', align: 'blabs', x: 0, y: 56 },
                    { name: 'thumbnail' },
                    {
                        name: 'controlBar', align: 'blabs', x: 0, y: 0,
                        children: [
                            { name: 'progress', align: 'blabs', x: 0, y: 44 },
                            { name: 'playButton', align: 'tl', x: 15, y: 12 },
                            { name: 'timeDisplay', align: 'tl', x: 10, y: 7 },
                            { name: 'fullScreenButton', align: 'tr', x: 10, y: 12 },
                            { name: 'volume', align: 'tr', x: 5, y: 10 }
                        ]
                    }
                ]
                // authTimeout: 7200, // 播放地址的有效时长，单位：秒。该时长会覆盖在视频点播控制台设置的URL鉴权的有效时长。如不传，则取默认值7200。如需设置此参数，请确保该时间大于视频的实际时长，防止播放地址在播放完成前过期。
            },function(player){
                console.log('The player is created.')
                // 进一步防御：禁用视频元素右键菜单与浏览器自带的下载/倍速/画中画按钮
                try {
                    const root = document.getElementById('J_prismPlayer')
                    if (root) {
                        root.oncontextmenu = () => false
                        const video = root.querySelector('video')
                        if (video) {
                            video.setAttribute('controlsList', 'nodownload noremoteplayback noplaybackrate')
                            video.setAttribute('disablePictureInPicture', 'true')
                            video.oncontextmenu = () => false
                        }
                    }
                } catch (e) { /* ignore */ }
            });
                    
        },
        getCurrentTime(){
            return this.aliplayer.getCurrentTime()
        },
        seekTo(time){
            if(this.aliplayer){
                this.aliplayer.seek(time)
                this.aliplayer.play()
            }
        }
    },
}
</script>

<style scoped lang="less">
/* 屏蔽阿里云播放器的下载 / 收藏 / 快照 / 倍速等左右导航按钮 */
/deep/ .prism-setting-btn,              /* 设置按钮（含倍速） */
/deep/ .prism-cc-setting-btn,
/deep/ .prism-setting-list,
/deep/ .prism-setting,
/deep/ .prism-speed,                    /* 倍速按钮 */
/deep/ .prism-speed-box,
/deep/ .prism-speed-btn,
/deep/ .prism-rate-btn,
/deep/ .prism-download,                 /* 下载按钮 */
/deep/ .prism-download-btn,
/deep/ .prism-favorite,                 /* 收藏按钮 */
/deep/ .prism-collect,
/deep/ .prism-snapshot-btn,             /* 截图按钮 */
/deep/ .prism-more-btn,                 /* 更多按钮 */
/deep/ .prism-cc-btn,
/deep/ .prism-ShowSnapshotBtn {
  display: none !important;
}
</style>